import { Panel, LabeledInput } from '@epam/promo';
import { ILens } from '@epam/uui';
import { Industries } from 'modules/project-management/update/components/industries';

const AboutProject = ({
  lens,
  className,
}: {
  lens: ILens<any>;
  className?: string;
}) => {
  return (
    <Panel background="white" cx={className ? `${className}__body` : ''}>
      <Panel cx={className ? `${className}__body__status` : ''}>
        <LabeledInput
          label="Project Details:"
          cx={className ? `${className}__body__status__title` : ''}
          isRequired
        />
        <Industries
          lens={lens.prop('industries')}
          industryTypeLens={lens.prop('industryType')}
          isRequired
        />
      </Panel>
    </Panel>
  );
};

export default AboutProject;
